// ParentActiveStep.jsx
import React, { useState, useEffect } from "react";
import top_bg from "../../Assets/img/top_bg.png";
import logo from "../../Assets/img/logo.svg";
import { Box, Typography, Divider, Button } from "@mui/material";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import ActiveStep1 from "./ActiveStep1";
import ActiveStep3 from "./ActiveStep3";
import ActiveStep4 from "./ActiveStep4";
import ActiveStep5 from "./ActiveStep5";
import ActiveStep8 from "./ActiveStep8";
import { Link } from "react-router-dom";

function ParentActiveStep2() {
  const isSignup=false
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    dob: '',
    personalEmail: '',
    profession: 'Personal',
    professionalEmail: '',
    phoneNo: '+' + '',
    password: '',
    confirmPassword: '',
    image: null
  });

  const [experience, setExperience] = useState({
    companyName: "",
    Role: "",
    website: "",
    emailId: "",
    startyear: "",
    startmonth: "",
    endmonth: "present",
    endyear: "present",
    iscurrentlyworking: true,
    is_verified: false,
    logo: "",
  });

  const [education, setEducation] = useState({
    institute: "",
    institute_domain: "",
    title: "",
    eduLevel: "",
    startyear: "",
    endyear: "present",
    iscurrentlypurusing: true,
    logo: "",
  });

  const [step1Data, setStep1Data] = useState({
    selectedImage: null,
    firstName: "",
    lastName: ""
  });

  const updateStep1Data = (data) => {
    setStep1Data(data);
  };

  // Track verification status for email and phone
  const [verificationStatus, setVerificationStatus] = useState({
    emailVerified: false,
    phoneVerified: false
  });

  // Track completed sections
  const [completedSections, setCompletedSections] = useState({
    profile: false,
    email: false,
    phone: false,
    password: false,
    resume: false
  });

  const updateFormData = (newData) => {
    setFormData(prev => ({ ...prev, ...newData }));
  };

  // Scroll to top of section
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  // Section completion statuses
  const isProfileComplete = () => {
    return formData.firstName?.trim() && 
           formData.lastName?.trim() && 
           formData.dob;
  };

  const isEmailComplete = () => {
    return formData.personalEmail && 
           /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.personalEmail);
  };

  const isPhoneComplete = () => {
    return formData.phoneNo && formData.phoneNo.length > 5;
  };

  const isPasswordComplete = () => {
    return formData.password && 
           formData.password?.length >= 8 
  };

  // Update completed sections based on verification status
  useEffect(() => {
    const profileComplete = isProfileComplete();
    const emailComplete = verificationStatus.emailVerified;
    const phoneComplete = isPhoneComplete() && verificationStatus.phoneVerified;
    const passwordComplete = isPasswordComplete();

    // console.log("=== Updating Completed Sections ===");
    // console.log("Email Verified:", verificationStatus.emailVerified);
    // console.log("Phone Verified:", verificationStatus.phoneVerified);
    // console.log("Profile Complete:", profileComplete);
    // console.log("Email Complete:", emailComplete);
    // console.log("Phone Complete:", phoneComplete);
    // console.log("Password Complete:", passwordComplete);

    setCompletedSections({
      profile: profileComplete,
      email: emailComplete,
      phone: phoneComplete,
      password: passwordComplete,
      resume: false
    });
  }, [formData, verificationStatus]);

  // Handler for email verification
  const handleEmailVerification = (status) => {
    console.log("📧 Email verification callback received:", status);
    setVerificationStatus(prev => {
      const newState = {
        ...prev,
        emailVerified: status
      };
      console.log("📧 New verification state:", newState);
      return newState;
    });
  };

  // Handler for phone verification
  const handlePhoneVerification = (status) => {
    console.log("📱 Phone verification callback received:", status);
    setVerificationStatus(prev => {
      const newState = {
        ...prev,
        phoneVerified: status
      };
      console.log("📱 New verification state:", newState);
      return newState;
    });
  };

  // Handler for step navigation
  const handleSetActiveStep = (stepNumber) => {
    console.log("Navigating to step:", stepNumber);
  };

  const steps = ["Profile", "Email", "Phone", "Password", "Resume"];

  // Get the completion status for each step
  const getStepCompletion = (index) => {
    const keys = ['profile', 'email', 'phone', 'password', 'resume'];
    return completedSections[keys[index]] || false;
  };

  // Calculate completion percentage
  const getCompletionPercentage = () => {
    const totalSteps = steps.length;
    const completedCount = Object.values(completedSections).filter(Boolean).length;
    return Math.round((completedCount / totalSteps) * 100);
  };

  // Get completion count
  const getCompletedCount = () => {
    return Object.values(completedSections).filter(Boolean).length;
  };

  return (
    <div className="scrollable-images-container">
      <img className="header-image" src={top_bg} alt="Header" />
      <div className="onboard_header">
        <img className="logo" src={logo} alt="Logo" />
      </div>

      {/* Welcome Section - Centered */}
      <Box sx={{ 
        maxWidth: 720, 
        mx: 'auto', 
        px: { xs: 2, sm: 3, md: 4 }, 
        pt: 2,
        pb: 1,
        textAlign: 'center'
      }}>
        <h2 className="onboard-slide-title" style={{fontSize:"32px", textAlign: 'center', marginBottom: '8px' }}>
          Hi, Welcome to Neoin!
        </h2>
        
        <Typography 
          variant="body2" 
          sx={{ 
            color: '#475569', 
            fontSize: '1.2rem',
            marginBottom: '16px',
            textAlign: 'center'
          }}
        >
          Already have an account?{' '}
          <Link 
            to="/login" 
            style={{ 
              color: '#0044C6', 
              fontWeight: 600,
              textDecoration: 'none',
              '&:hover': {
                textDecoration: 'underline'
              }
            }}
          >
            Login
          </Link>
        </Typography>

        {/* Progress Indicator */}
        <Box sx={{ 
          maxWidth: 720, 
          mx: 'auto', 
          px: { xs: 2, sm: 3, md: 4 }, 
          pt: 2,
          pb: 1
        }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
            <Typography variant="h6" sx={{ fontWeight: 700, color: '#0f172a', mr:"10px" }}>
              Complete Your Profile 
            </Typography>
            <Typography sx={{ color: '#475569', fontSize: '0.85rem' }}>
              {getCompletedCount()} of {steps.length} completed ({getCompletionPercentage()}%)
            </Typography>
          </Box>
          
          {/* Progress Bar with Percentage */}
          <Box sx={{ display: 'flex', gap: 1, mb: 1 }}>
            {steps.map((label, index) => {
              const isComplete = getStepCompletion(index);
              return (
                <Box
                  key={index}
                  onClick={() => scrollToSection(`section-${index}`)}
                  sx={{
                    flex: 1,
                    height: 6,
                    borderRadius: 3,
                    bgcolor: isComplete ? '#0044C6' : '#e0e0e0',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      opacity: 0.8,
                      transform: 'scaleY(1.5)',
                    }
                  }}
                />
              );
            })}
          </Box>
          
          {/* Percentage Display */}
          <Box sx={{ 
            display: 'flex', 
            justifyContent: 'flex-end',
            mt: 0.5
          }}>
            <Typography sx={{ 
              color: '#0044C6', 
              fontSize: '0.75rem',
              fontWeight: 600
            }}>
              {getCompletionPercentage()}% Complete
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* All Steps in One Scrollable Page */}
      <Box sx={{ maxWidth: 720, mx: 'auto', px: { xs: 2, sm: 3, md: 4 }, py: 2 }}>
        {/* Step 1: Profile */}
        <Box id="section-0" sx={{ mb: 4 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
            <Box sx={{ 
              width: 32, 
              height: 32, 
              borderRadius: '50%', 
              bgcolor: completedSections.profile ? '#0044C6' : '#e0e0e0',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: completedSections.profile ? '#fff' : '#999',
              fontWeight: 600,
              fontSize: '0.85rem'
            }}>
              {completedSections.profile ? <CheckCircleRoundedIcon sx={{ fontSize: 18 }} /> : '1'}
            </Box>
            <Typography variant="h6" sx={{ fontWeight: 700, color: '#0f172a' }}>
              Profile Information
            </Typography>
            {completedSections.profile && (
              <Typography sx={{ color: '#4caf50', fontSize: '0.75rem', ml: 'auto' }}>
                ✓ Complete
              </Typography>
            )}
          </Box>
          
          <Box sx={{ 
            p: { xs: 2, sm: 3 }, 
            bgcolor: '#f8fbff', 
            borderRadius: 3,
            border: '1px solid rgba(0,68,198,0.08)',
          }}>
            <ActiveStep1 
              setFormData={setFormData} 
              setActiveStep={() => scrollToSection('section-1')}
              step1Data={step1Data} 
              updateStep1Data={updateStep1Data}
              isSignup={isSignup} 
            />
          </Box>
        </Box>

        <Divider sx={{ my: 3, borderColor: 'rgba(0,68,198,0.12)' }} />

        {/* Step 2: Email */}
        <Box id="section-1" sx={{ mb: 4 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
            <Box sx={{ 
              width: 32, 
              height: 32, 
              borderRadius: '50%', 
              bgcolor: verificationStatus.emailVerified ? '#0044C6' : '#e0e0e0',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: verificationStatus.emailVerified ? '#fff' : '#999',
              fontWeight: 600,
              fontSize: '0.85rem'
            }}>
              {verificationStatus.emailVerified ? <CheckCircleRoundedIcon sx={{ fontSize: 18 }} /> : '2'}
            </Box>
            <Typography variant="h6" sx={{ fontWeight: 700, color: '#0f172a' }}>
              Email Verification
            </Typography>
            {verificationStatus.emailVerified ? (
              <Typography sx={{ color: '#4caf50', fontSize: '0.75rem', ml: 'auto' }}>
                ✓ Verified
              </Typography>
            ) : isEmailComplete() && (
              <Typography sx={{ color: '#ff9800', fontSize: '0.75rem', ml: 'auto' }}>
                ⚠️ Verify OTP
              </Typography>
            )}
          </Box>
          
          <Box sx={{ 
            p: { xs: 2, sm: 3 }, 
            bgcolor: '#f8fbff', 
            borderRadius: 3,
            border: '1px solid rgba(0,68,198,0.08)'
          }}>
            <ActiveStep3 
              setFormData={setFormData}
              activeStep={1}
              setActiveStep={handleSetActiveStep}
              experience={experience} 
              education={education}
              onVerificationComplete={handleEmailVerification}
              verificationStatus={verificationStatus}
              isSignup={isSignup}
            />
          </Box>
        </Box>

        <Divider sx={{ my: 3, borderColor: 'rgba(0,68,198,0.12)' }} />

        {/* Step 3: Phone */}
        <Box id="section-2" sx={{ mb: 4 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
            <Box sx={{ 
              width: 32, 
              height: 32, 
              borderRadius: '50%', 
              bgcolor: verificationStatus.phoneVerified ? '#0044C6' : '#e0e0e0',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: verificationStatus.phoneVerified ? '#fff' : '#999',
              fontWeight: 600,
              fontSize: '0.85rem'
            }}>
              {verificationStatus.phoneVerified ? <CheckCircleRoundedIcon sx={{ fontSize: 18 }} /> : '3'}
            </Box>
            <Typography variant="h6" sx={{ fontWeight: 700, color: '#0f172a' }}>
              Phone Verification
            </Typography>
            {verificationStatus.phoneVerified ? (
              <Typography sx={{ color: '#4caf50', fontSize: '0.75rem', ml: 'auto' }}>
                ✓ Verified
              </Typography>
            ) : isPhoneComplete() && (
              <Typography sx={{ color: '#ff9800', fontSize: '0.75rem', ml: 'auto' }}>
                ⚠️ Verify OTP
              </Typography>
            )}
          </Box>
          
          <Box sx={{ 
            p: { xs: 2, sm: 3 }, 
            bgcolor: '#f8fbff', 
            borderRadius: 3,
            border: '1px solid rgba(0,68,198,0.08)'
          }}>
            <ActiveStep4 
              setFormData={setFormData}
              activeStep={2}
              setActiveStep={handleSetActiveStep}
              formData={formData}
              onVerificationComplete={handlePhoneVerification}
              verificationStatus={verificationStatus}
              isSignup={isSignup}
            />
          </Box>
        </Box>

        <Divider sx={{ my: 3, borderColor: 'rgba(0,68,198,0.12)' }} />

        {/* Step 4: Password */}
        <Box id="section-3" sx={{ mb: 4 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
            <Box sx={{ 
              width: 32, 
              height: 32, 
              borderRadius: '50%', 
              bgcolor: completedSections.password ? '#0044C6' : '#e0e0e0',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: completedSections.password ? '#fff' : '#999',
              fontWeight: 600,
              fontSize: '0.85rem'
            }}>
              {completedSections.password ? <CheckCircleRoundedIcon sx={{ fontSize: 18 }} /> : '4'}
            </Box>
            <Typography variant="h6" sx={{ fontWeight: 700, color: '#0f172a' }}>
              Create Password
            </Typography>
            {completedSections.password && (
              <Typography sx={{ color: '#4caf50', fontSize: '0.75rem', ml: 'auto' }}>
                ✓ Complete
              </Typography>
            )}
          </Box>
          
          <Box sx={{ 
            p: { xs: 2, sm: 3 }, 
            bgcolor: '#f8fbff', 
            borderRadius: 3,
            border: '1px solid rgba(0,68,198,0.08)'
          }}>
            <ActiveStep5 
              formData={formData} 
              setFormData={setFormData} 
              education={education} 
              activeStep={3}
              setActiveStep={handleSetActiveStep}
              experience={experience} 
              isSignup={isSignup}
            />
          </Box>
        </Box>

        <Divider sx={{ my: 3, borderColor: 'rgba(0,68,198,0.12)' }} />

        {/* Step 5: Resume */}
        <Box id="section-4" sx={{ mb: 4 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
            <Box sx={{ 
              width: 32, 
              height: 32, 
              borderRadius: '50%', 
              bgcolor: '#e0e0e0',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#999',
              fontWeight: 600,
              fontSize: '0.85rem'
            }}>
              5
            </Box>
            <Typography variant="h6" sx={{ fontWeight: 700, color: '#0f172a' }}>
              Resume Upload
            </Typography>
            <Typography sx={{ color: '#999', fontSize: '0.75rem', ml: 'auto' }}>
              Optional
            </Typography>
          </Box>
          
          <Box sx={{ 
            p: { xs: 2, sm: 3 }, 
            bgcolor: '#f8fbff', 
            borderRadius: 3,
            border: '1px solid rgba(0,68,198,0.08)'
          }}>
            <ActiveStep8 
              setActiveStep={() => {}} 
            />
          </Box>
        </Box>
      </Box>
    </div>
  );
}

export default ParentActiveStep2;